import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PortOptComponent } from './port-opt/port-opt.component';
import { RtTransComponent } from './rt-trans/rt-trans.component';
import { MatRipple } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
  declarations: [LoaderComponent,RtTransComponent, EmptyStateComponent, PortOptComponent],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatRipple,
    MatTooltip
  ],
  exports: [
    LoaderComponent,
    EmptyStateComponent,
    PortOptComponent,
    RtTransComponent
  ]
})
export class SharedModule { }
